<template lang="pug">
section
  v-btn(:small="dense" text @click.prevent="deleteDialog = true")
    v-icon(v-if="icon" :left="!!deleteText" :style="{ opacity: 0.3 }") {{ icon }}
    v-icon(v-else :left="!!deleteText" :style="{ opacity: 0.3 }") mdi-delete
    span(v-if="deleteText") {{ deleteText }}

  v-dialog( width="500" v-model="deleteDialog" @click:outside="deleteDialog = false")
    v-card
      v-card-title.justify-left(v-if="title") {{ title }}
      v-card-title.justify-left(v-else) Möchtest du den Datensatz wirklich löschen?
      v-card-text(v-if="info")
        h2 {{info}}
      v-card-actions
        v-btn( @click="deleteDialog = false" text).
          zurück
        v-spacer
        v-btn.red( dark @click="confirmDeletion()" depressed).
          ok
</template>

<script>
export default {
  props: ['info', 'title', 'icon', 'dense', 'deleteText'],
  data: () => ({
    deleteDialog: false
  }),
  methods: {
    confirmDeletion() {
      this.$emit('confirm')
      this.deleteDialog = false
    }
  }
}
</script>